import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["value", "thumbsUp", "thumbsDown"]

  // before submitting form, change hidden field value
  changeRating(event) {
    event.preventDefault()
    this.valueTarget.value = event.currentTarget.dataset.value
    this.element.requestSubmit()
  }
}